import { render } from "./ReglePastille.vue?vue&type=template&id=4a644520&scoped=true&ts=true"
import script from "./ReglePastille.vue?vue&type=script&lang=ts"
export * from "./ReglePastille.vue?vue&type=script&lang=ts"

import "./ReglePastille.vue?vue&type=style&index=0&id=4a644520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a644520"]])

export default __exports__